(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-product-recommendations"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        #cachedRecommendations = {};

        connectedCallback() {
            this.#loadRecommendations();
        }

        async #loadRecommendations() {
            const { productId, sectionId, intent, url } = this.dataset;

            if (!productId || !url) {
                console.error('Product ID and URL are required');
                return;
            }

            const fullUrl = `${url}&product_id=${productId}&section_id=${sectionId}&intent=${intent}`;
            const cacheKey = fullUrl;

            try {
                let html;
                if (this.#cachedRecommendations[cacheKey]) {
                    html = this.#cachedRecommendations[cacheKey];
                } else {
                    const response = await fetch(fullUrl);
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    html = await response.text();
                    this.#cachedRecommendations[cacheKey] = html;
                }

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const recommendations = doc.querySelector('product-recommendations');

                if (recommendations?.innerHTML && recommendations.innerHTML.trim().length) {
                    // Get the ul from response
                    const responseUl = recommendations.querySelector('ul');
                    const currentUl = this.querySelector('ul');

                    if (responseUl && currentUl) {
                        // Check if complementary intent with no recommendations
                        if (this.dataset.intent === 'complementary' && responseUl.dataset.hasRecommendations === 'false') {
                            this.setAttribute('data-error', 'No complementary products');
                            return;
                        }

                        // Replace placeholder items with real products
                        const placeholders = currentUl.querySelectorAll('li[data-has-recommendations="false"]');
                        const realItems = Array.from(responseUl.querySelectorAll('li'));

                        placeholders.forEach((placeholder, index) => {
                            if (realItems[index]) {
                                placeholder.replaceWith(realItems[index].cloneNode(true));
                            }
                        });
                    } else {
                        // Fallback: replace entire innerHTML
                        this.innerHTML = recommendations.innerHTML;
                    }
                } else {
                    this.#handleError(new Error('No recommendations available'));
                }
            } catch (error) {
                this.#handleError(error);
            }
        }

        #handleError(error) {
            console.error('Product recommendations error:', error.message);
            this.setAttribute('data-error', 'Error loading product recommendations');
        }
    }

    if (!customElements.get('product-recommendations')) {
        customElements.define('product-recommendations', ProductRecommendations);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300))
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
